export default __webpack_public_path__ + "static/media/af4.c930727f.jpg";